import { Button } from "antd";
import { FindingBucketContextType } from "contexts/FindingBucketContext";
import _ from "lodash";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import AssessmentAPI from "restAPI/AssessmentAPI";
import { AssessmentResponseDto } from "types/assessment";
import { FilterInfo } from "types/pagination";
import AssessmentsFormPopup from "views/Inventory/Assessments/AssessmentsFormPopup";

import CustomSelect from "./CustomSelect";
import Vocabulary from "./Vocabulary";

const AssessmentSelectWithAddButton = ({
  showAddButton,
  onCreate,
  bucket,
  ...rest
}: {
  showAddButton?: boolean;
  onCreate?: (assessment: AssessmentResponseDto) => void;
  bucket: FindingBucketContextType;
} & React.ComponentProps<typeof CustomSelect>) => {
  const [open, setOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [assessments, setAssessments] =
    useState<Array<{ label: string; value: number }>>();

  const assessmentsPayload = useMemo(() => {
    let filters: FilterInfo[] = [];
    let payload;
    const { findingIds, filterMap } = bucket;
    if (!_.isEmpty(filterMap)) {
      filters = _.compact(Object.values(filterMap));
    } else if (findingIds.length) {
      filters = [
        {
          id_term: [...findingIds],
        },
      ];
    }
    if (filters.length) {
      payload = { filters: filters[0] };
    }
    return payload;
  }, [bucket]);

  useEffect(() => {
    const { promise, cancel } =
      AssessmentAPI.getFilteredAssessments(assessmentsPayload);
    promise.then((res) => {
      setAssessments(
        //@ts-expect-error
        res.data.map((option) => ({
          label: option.name,
          value: option.id,
        })),
      );
    }, _.noop);
    return cancel;
  }, [assessmentsPayload]);

  const onButtonClick = useCallback(() => {
    setOpen(false);
    setIsModalOpen(true);
  }, []);

  return (
    <>
      <CustomSelect
        {...rest}
        style={{ width: "56%" }}
        open={open}
        onDropdownVisibleChange={setOpen}
        placeholder={
          <>
            Select <Vocabulary name={"assessment"} />
          </>
        }
        loading={_.isNil(assessments)}
        options={assessments}
      />
      <Button
        style={{ width: "40%", float: "right" }}
        name={"assessment"}
        block
        onClick={onButtonClick}
      >
        <>
          Add <Vocabulary name={"assessment"} />
        </>
      </Button>
      {isModalOpen ? ( //to prevent retaining old fetched form data
        <AssessmentsFormPopup
          open={isModalOpen}
          onOk={() => {}}
          onCancel={() => setIsModalOpen(false)}
          onSuccess={(createdAssessment) => {
            if (createdAssessment) {
              const updatedAssessments = [
                {
                  label: createdAssessment.name,
                  value: createdAssessment.id,
                },
                ...(assessments || []),
              ];
              setAssessments(updatedAssessments);
              onCreate?.(createdAssessment);
              setIsModalOpen(false);
            } else {
              setIsModalOpen(false);
            }
          }}
        />
      ) : null}
    </>
  );
};

export default AssessmentSelectWithAddButton;
